var Slugifier = /** @class */ (function () {
    function Slugifier(stringToBeSlugified) {
        if (stringToBeSlugified === void 0) { stringToBeSlugified = ''; }
        this.slug = stringToBeSlugified;
    }
    Slugifier.prototype.slugify = function (stringToBeSlugified, delimiter) {
        if (stringToBeSlugified === void 0) { stringToBeSlugified = this.slug; }
        if (delimiter === void 0) { delimiter = '-'; }
        this.slug = stringToBeSlugified;
        this.replaceAccents().replaceSpecialChars(delimiter).removeNonWord().makeSlug(delimiter);
        return this.slug;
    };
    Slugifier.prototype.replaceSpecialChars = function (delimiter) {
        this.slug = this.slug.replace(/[\x40]/g, 'at');
        this.slug = this.slug.replace(/[\x27-\x29\x2A-\x2F\x5C]/g, delimiter); // ',/,\,(,),*,+,,,-
        return this;
    };
    Slugifier.prototype.removeNonWord = function () {
        var PATTERN = /[^\x20\x2D0-9A-Z\x5Fa-z\xC0-\xD6\xD8-\xF6\xF8-\xFF]/g;
        this.slug = this.slug.replace(PATTERN, '');
        return this;
    };
    Slugifier.prototype.replaceAccents = function () {
        var replaceAccents = function (string) {
            return string.replace(/[\xC0-\xC3]/g, "A")
                .replace(/[\xC4-\xC6]/g, "AE")
                .replace(/[\xC7]/g, "C")
                .replace(/[\xC8-\xCB]/g, "E")
                .replace(/[\xCC-\xCF]/g, "I")
                .replace(/[\xD0]/g, "D")
                .replace(/[\xD1]/g, "N")
                .replace(/[\xD2-\xD5\xD8]/g, "O")
                .replace(/[\xD6]/g, "OE")
                .replace(/[\xD9-\xDB]/g, "U")
                .replace(/[\xDC]/g, "UE")
                .replace(/[\xDD]/g, "Y")
                .replace(/[\xDE]/g, "P")
                .replace(/[\xDF]/g, "ss")
                .replace(/[\xE0-\xE3]/g, "a")
                .replace(/[\xE4-\xE6]/g, "ae")
                .replace(/[\xE7]/g, "c")
                .replace(/[\xE8-\xEB]/g, "e")
                .replace(/[\xEC-\xEF]/g, "i")
                .replace(/[\xF1]/g, "n")
                .replace(/[\xF2-\xF5\xF8]/g, "o")
                .replace(/[\xF6]/g, "oe")
                .replace(/[\xF9-\xFB]/g, "u")
                .replace(/[\xFC]/g, "ue")
                .replace(/[\xFE]/g, "p")
                .replace(/[\xFD\xFF]/g, "y");
        };
        this.slug = this.slug.search(/[\xC0-\xFF]/g) > -1 ? replaceAccents(this.slug) : this.slug;
        return this;
    };
    Slugifier.prototype.makeSlug = function (delimiter) {
        if (delimiter === void 0) { delimiter = '-'; }
        var trailingDelimiterRegex = new RegExp('^' + delimiter + '+|' + delimiter + '+$', 'g');
        this.slug = this.slug.trim().replace(trailingDelimiterRegex, '').replace(/ +/g, delimiter).replace(/\-+/g, delimiter).toLowerCase();
        return this;
    };
    return Slugifier;
}());
export { Slugifier };
export default Slugifier;
